<template>
  <div>
    <div class="cover">
      <video class="video" autoplay muted loop playsinline>
        <source 
          :src="`${cdn_archivos_dominio}/portada/piesagiles-${
            esMovil ? 'celular' : 'escritorio'}.webm`" 
          type="video/webm">
      </video>
      <div class="cover-gradient">
        <div class="cover-text">
          <h1 class="cover-title a11y-contraste-fondo">PIES-AGILES</h1>
          <h2 class="cover-subtitle a11y-contraste-fondo">
            Un capítulo del Ecosistema Nacional Informático de
            {{ obtenerNombreEni }}
          </h2>
        </div>
      </div>
    </div>
    <div class="container text m-y-2 a11y-simplificada-block">
      <h2 class="titular-portada m-t-3-sm m-t-2-md m-x-auto">PIES-AGILES</h2>
      <h2 class="titular-portada sub m-x-auto">
        Un capítulo del Ecosistema Nacional Informático de
        {{ obtenerNombreEni }}
      </h2>
    </div>
    <div class="container text">
      <h3 class="titular-bajo titular-bajo-pies texto-centrado titulo-left-movil m-t-4-md">
        Programa Interinstitucional de Especialidad en Soberanías Alimentarias y Gestión de
        Incidencia Local Estratégica
        <br />( PIES-AGILES )
      </h3>
      <p class="m-y-1-sm m-y-2-md">
        El Conahcyt, a través del Programa Interinstitucional de Especialidad en Soberanías
        Alimentarias y Gestión de Incidencia Local Estratégica (PIES AGILES), impulsa la ciencia
        horizontal y de incidencia. Como programa educativo inaugurado en 2021 en 18 estados,
        responde al objetivo de promover las agroecologías y la soberanía alimentaria. Las y los 280
        becarios actualmente inscritos, ensayan distintas posibilidades para rediseñar
        agroecosistemas y fortalecer comunidades de aprendizaje con prácticas de innovación libres
        de glifosato y otros agrotóxicos. El contenido curricular del programa es mixto, virtual y
        en campo y tiene como eje metodológico la investigación acción participativa. Las y los
        becarios se especializan en impulsar procesos de formación e incidencia territorial mediante
        el estudio e implementación de distintas prácticas agroecológicas como la experimentación
        con bioinsumos, el intercambio de semillas, la protección a polinizadores, la
        agroforestería, el rescate de la gastronomía local, manejos colectivos del agua y la
        organización colectiva, desde un enfoque de justicia social y de equidad de género.
      </p>
    </div>
    <div class="container main">
      <h4 class="titular-bajo texto-centrado texto-podcast-pies titulo-left-movil">
        Podcast
      </h4>
      <div class="tablero-podcast m-b-2 container-podcast">
        <Podcast
          v-for="item in randomList"
          :key="item.id"
          :identificador="'modal-leer-mas' + item.id"
          :autor="item.autores"
          :card_imagen="item.imagen"
          :casa="item.casa"
          :descripcion="item.descripcion"
          :fecha="item.anio"
          :titulo="item.titulo"
          :url="item.url"
        />
      </div>
      <div class="container texto-centrado">
        <button class="boton-repo boton-plataforma a11y-enlace-subrayado" onclick="window.open('https://repositorio-alimentacion.conacyt.mx/jspui/handle/1000/35','_blank')">
          Escuchar todos los episodios
          <img alt="" class="icono-repo" src="../assets/icons/enlace-icon.svg" />
        </button>
      </div>
    </div>
    <div>
      <Lineamientos />
    </div>
    <div class="container text m-y-1-sm m-y-3-md a11y-ocultar-imagen-link">
      <h4 class="titular texto-centrado titulo-center-movil">Acerca de CIATEJ</h4>
      <p>
        El Centro de Investigación y Asistencia en Tecnología y Diseño del Estado de Jalisco, A.C.
        (CIATEJ) es un Centro de Investigación que pertenece a la Coordinación de Medio Ambiente,
        Salud y Alimentación del Sistema de Centros Públicos de Investigación (CPI) del Consejo
        Nacional de Humanidades, Ciencias y Tecnologías (Conahcyt).
      </p>
      <div class="container texto-centrado m-y-3-md">
        <button class="boton-ciatej btn-bold a11y-enlace-subrayado" onclick="window.open('https://ciatej.mx/', '_blank')">
          Ir al CIATEJ
        </button>
      </div>
      <h4 class="titular texto-centrado titulo-center-movil">Contacto</h4>
      <div class="contacto">
        <img alt=" " class="imagen" src="../assets/icons/email-icon.svg" />
        <p>piesagiles@ciatej.mx</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Lineamientos from "@/components/Lineamientos.vue";
import PodcasList from "@/assets/data/listado_podcast.json";
import Podcast from "@/components/Podcast.vue";

export default {
  name: "Inicio",
  components: {
    Lineamientos,
    Podcast,
  },
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      PodcasList,
    };
  },
  computed: {
    ...mapState(["cdn_archivos_dominio"]),
    esMovil() {
      return Boolean(window.innerWidth < 768);
    },
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
    randomList() {
      return PodcasList.sort(function () {
        return 0.5 - Math.random();
      }).slice(0, 8);
    },
  },
};
</script>

<style lang="scss" scoped>
.cover {
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    &.hidden{
      display: none;
    }
  }
}

.cover-gradient {
  padding: $gap * 4 $gap $gap;
  .cover-logos {
    margin-top: 200px;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      width: 400px;
    }
  }
  .cover-text {
    padding-top: 80px;
    margin: 0px auto;
  }

  @media (min-width: map-get($media-queries-limit, "mobile")) {
    padding-top: $gap * 3;
  }
}

h4.titulo-left-movil,
h3.titulo-left-movil {
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    text-align: left;
  }
}

.btn-external {
  font-size: map-get($fuente, "size-alto");
  border-radius: $gap;
  padding: 0 0 0 $gap;
  text-align: center;

  .icono {
    margin-left: $gap;
    transition: margin-left 0.3s ease-in-out;
  }

  .icono::before {
    background: map-get($color-boton, "texto");
    border: 1px solid map-get($color-boton, "fondo");
    color: map-get($color-boton, "fondo");
    font-size: 40px;
    line-height: $gap * 1.5;
    width: $gap * 1.5;
    height: $gap * 1.5;
    border-radius: $gap * 1.5;
    transition: all 0.3s ease-in-out;
  }

  &:hover,
  &:focus {
    .icono {
      margin-left: $gap * 1.5;
    }

    .icono::before {
      background: map-get($color-boton, "hover-texto");
      border: 1px solid map-get($color-boton, "hover-fondo");
      color: map-get($color-boton, "hover-fondo");
    }
  }
}

.video-responsivo {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.contacto {
  display: flex;
  justify-content: center;
  align-items: center;
}

.boton-ciatej {
  top: 4106px;
  left: 616px;
  width: 135px;
  height: 51px;
  color: #d13560;
  background: #ffffff;
  border: 2px solid #d13560;
  border-radius: 5px;
  opacity: 1;
  align-self: center;
}

.boton-ciatej:hover {
  background-color: white;
  box-shadow: 2px 2px 10px #00000029;
}

.boton-ciatej:focus {
  background-color: #d1889d;
  color: #ffffff;
}

.boton-repo {
  top: 2275px;
  left: 557px;
  width: 301px;
  height: 68px;
  border-radius: 5px;
  background-color: #d13560;
  color: #fff;
  align-self: center;
  font-size: 16px;
  font-weight: 500;

  &:focus,
  &:hover {
    background-color: #d1889d;
    color: #ffffff;
    box-shadow: 2px 2px 10px #00000029;
  }

  .icono-repo {
    margin-left: 6px;
    filter: invert(99%) sepia(99%) saturate(3%) hue-rotate(68deg) brightness(103%) contrast(100%);
  }
}

.tablero-podcast {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}


</style>
